import cn from 'classnames';
import { DateTime } from 'luxon';
import { memo, useEffect, useState, type FC } from 'react';
import * as st from './styles.module.scss';

type Props = {
  timeout: number;
  callback: () => void;
  className?: string;
};

const Timer: FC<Props> = ({ timeout, callback, className }) => {
  const [time, setTime] = useState<number>(timeout);

  useEffect(() => {
    if (time > 0) {
      const timeout = setTimeout(() => {
        setTime(time - 1000);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    } else {
      callback();
    }
  }, [time, setTime, callback]);
  return (
    <div className={cn(st.timer, className)}>
      {DateTime.fromMillis(time).isValid && `${DateTime.fromMillis(time).toFormat('ss')} сек`}
    </div>
  );
};

export default memo(Timer);
